export const THOUSAND_SEPARATOR = ' ';
export const TRACE_ID_NAME = 'x-housing-trace-id';
export const EMPTY_VALUE = '—';
export const LTV_THRESHOLD = 90;
export const INTEREST_RATE_CALCULATION_DATE = new Date(2026, 5, 1); // Jun 1, 2026
